import React, { useEffect } from 'react';
import { Printer } from 'lucide-react';

/**
 * Print button (#194): calls `window.print()`, and owns the one piece of print
 * behaviour CSS cannot express. `inline-expand` sections render as native
 * `<details>`, and a closed `<details>`' content cannot be revealed by page CSS
 * (the UA hides it via internal slotting), so `beforeprint` opens every closed
 * one and `afterprint` restores exactly those. The listeners cover Ctrl+P as
 * well as this button — both funnel through the same browser events.
 *
 * The button itself never prints: the print layer in index.css hides every
 * `button`.
 */
export default function PrintButton() {
  useEffect(() => {
    const opened = [];
    const before = () => {
      document.querySelectorAll('details:not([open])').forEach((d) => {
        d.open = true; // eslint-disable-line no-param-reassign
        opened.push(d);
      });
    };
    const after = () => {
      while (opened.length) opened.pop().open = false;
    };
    window.addEventListener('beforeprint', before);
    window.addEventListener('afterprint', after);
    return () => {
      window.removeEventListener('beforeprint', before);
      window.removeEventListener('afterprint', after);
    };
  }, []);

  return (
    <button
      type="button"
      onClick={() => window.print()}
      className="flex-shrink-0 p-1 mt-1 transition-transform duration-150 hover:scale-110"
      aria-label="Print"
      title="Print"
    >
      <Printer className="w-5 h-5" style={{ color: 'var(--text-muted)' }} aria-hidden="true" />
    </button>
  );
}
